import { AppTooltip } from '@lmt/unicorn-shared/app/components/common/ui-kit/tooltip/AppTooltip';
import { emailRegexp } from '@lmt/unicorn-shared/app/helpers/form/react-hook-form-helper';
import React, { FC } from 'react';
import { UniLink } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/UniLink';
import { ButtonColor } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';

import styles from './PlannedVisitsPanel.module.scss';

interface Props {
  title: string;
  contacts: string[];
}

export const MoreContactsPopup: FC<Props> = (props) => {
  const { title, contacts } = props;

  return (
    <AppTooltip
      arrow={true}
      title={
        <div className={styles.comment}>
          <div className={styles.tooltipItems}>
            {contacts.map((contact) => {
              return (
                <div key={contact} className={styles.tooltipItem}>
                  {contact.match(emailRegexp) ? (
                    <UniLink
                      title={contact}
                      color={ButtonColor.Primary}
                      href={`mailto:${contact}`}
                    />
                  ) : (
                    <span>{contact}</span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      }
    >
      <UniLink
        className={styles.contacts}
        title={title}
        color={ButtonColor.Primary}
      />
    </AppTooltip>
  );
};
